<template>
  <div>
    <div>
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        :hide-required-asterisk="false"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div class="add-box dis-flex">
          <div>
            <el-form-item label="名称">
              <el-input
                :placeholder="rules.title[0].message"
                v-model="ruleForm.title"
              ></el-input>
            </el-form-item>
            <el-form-item label="链接">
              <el-input
                placeholder="请输入图片链接"
                v-model="ruleForm.url"
              ></el-input>
            </el-form-item>
			<el-form-item label="状态">
				<el-radio-group v-model="ruleForm.status">
				  <el-radio label="1"  >启用</el-radio>
				  <el-radio label="0" >禁用</el-radio>
			    </el-radio-group>
			</el-form-item>
			<el-form-item label="排序">
			  <el-input
				type="number"
			    placeholder="请输入图片排序"
			    v-model="ruleForm.sort"
			  ></el-input>
			</el-form-item>
			<el-form-item label="轮播图片" >
				<el-upload
				:before-upload="beforeUpload"
				  :on-success="onSuccess"
				  :action="action"
				  :limit="1"
				  :multiple="true"
				  :file-list="fileList"
				  list-type="picture-card"
				  :on-preview="handlePictureCardPreview"
				  :on-remove="handleRemove">
				  <i class="el-icon-plus"></i>
				</el-upload>
			</el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="row1">
      <div>
        <el-button
          @click="submitForm('ruleForm')"
          class="row-btn add"
          type="primary"
          size="small"
          >{{type == 1?'提交':'修改'}}</el-button>
        <el-button
          @click="back"
          class="row-btn add back"
          type="primary"
          size="small"
          >返回</el-button
        >
      </div>
      
    </div>
  </div>
</template>

<script>
import * as imageConversion from 'image-conversion'
export default {
  data() {
    return {
	action:'',//上传图片地址
	fileList:[],
	type:'',//1为添加，2为修改
	options:[],
	options2:[],
      ruleForm: {
        title: "",
        status: '1',
		sort:'',
		url: '',
		image: '',
      },
      rules: {
        title: [
          { required: true, message: "请输入轮播图名称", trigger: ["blur","change"] },
        ],
		img: [
		  { required: true, message: "请上传轮播图", trigger: ["change"] },
		],
      },
    };
  },
  created() {
	  this.action = this.$baseUrl + '/admin/ajax/upload?PHPSESSID='+this.getCookie('PHPSESSID')
	this.type = this.$route.query.type //1为添加，2为修改
	if(this.$route.query.type == 2){
		for(let key in this.ruleForm){
			this.ruleForm[key] = this.$route.query[key]
		}
		this.fileList[0] = {
			url:this.ruleForm.image,
		} 
		this.ruleForm.id = this.$route.query.id
	}
  },
  methods: {
	  beforeUpload(file){
	  	return new Promise((resolve, reject) => {
			imageConversion.compress(file,0.8).then(res => { 
			  console.log(file);
			  resolve(res)
			})
	  		// let isLt2M = file.size / 1024 / 1024 < 4 // 判定图片大小是否小于4MB
	  		// console.log(isLt2M);
	  		// if (isLt2M) {
	  		//    resolve(file)
	  		// }else{
	  		// 	// console.log(file) // 压缩到400KB,这里的400就是要压缩的大小,可自定义
	  		// 	imageConversion.compressAccurately(file, 400).then(res => { // console.log(res)
	  		// 	  console.log(file);
	  		// 	  resolve(res)
	  		// 	})
	  		// }
	  	})
	  },
	  //上传图片回调
	  onSuccess(response, file, fileList){
	  	this.addOrDel = true;
	  	// this.ruleForm.images = []
	  	fileList.forEach((v,k)=>{
	  		if(v.id){
	  			// this.ruleForm.images.push(v.url)
				this.ruleForm.image = v.url
	  		}else{
	  			let response = v.response
	  			if(response.code == 1){
	  				// this.ruleForm.images.push(response.data.url)
					this.ruleForm.image = response.data.url
	  			}else{
	  				this.$message.error(res.msg)
	  			}
	  		}
	  	})
	  	console.log(this.ruleForm.image);
	  },
	  //移除图片
	  handleRemove(file, fileList) {
	  	this.addOrDel = true;
	  	console.log(file, fileList);
	  	this.ruleForm.image = ''
	  	fileList.forEach((v,k)=>{
	  		if(v.id){
	  			// this.ruleForm.images.push(v.id)
				this.ruleForm.image = v.url
	  		}else{
	  			let response = v.response
	  			if(response.code == 1){
	  				// this.ruleForm.images.push(response.data.id)
					this.ruleForm.image = response.data.url
	  			}else{
	  				this.$message.error(res.msg)
	  			}
	  		}
	  	})
	  	console.log('-------移除后-------');
	  	console.log(this.ruleForm.image);
	    },
	  handlePictureCardPreview(file) {
		this.dialogImageUrl = file.url;
		this.diaVisible = true;
	  },
	  // 返回
	  back(){
	    this.$router.go(-1)
	  },
    //   提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
			console.log(this.ruleForm);
			if(!this.ruleForm.image){
				return this.$message.error('请上传图片')
			}
			//1为添加，2为修改
          if(this.type == 1){
			  this.$api2.addBanner(this.ruleForm).then((res)=>{
			  	if(res.code == 1){
			  		this.$message.success(res.msg)
					setTimeout(()=>{
						// this.$router.push({ path: "/sys_setMeal_index"});
						this.$router.go(-1)
					},1.5e3)
			  	}else{
			  		this.$message.error(res.msg)
			  	}
			  })
		  }else if(this.type == 2){
			  this.$api2.editBanner(this.ruleForm).then((res)=>{
			  	if(res.code == 1){
			  		this.$message.success(res.msg)
					setTimeout(()=>{
						// this.$router.push({ path: "/sys_setMeal_index"});
						this.$router.go(-1)
					},1.5e3)
			  	}else{
			  		this.$message.error(res.msg)
			  	}
			  })
		  }
        } else {
          this.$message.error("请输入必填项！");
          return false;
        }
      });
    },
	// 获取cookie
	getCookie(name) {
	 var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	 if (arr = document.cookie.match(reg))
	  return (arr[2]);
	 else
	  return null;
	},
  },
};
</script>

<style lang="scss" scoped>
.row1 {
  padding-top: 20px;
  .add {
    padding: 12px 35px;
  }
  .back{
    background-color: #fff;
    color: gray;
    border: 1px solid #DCDFE6;
  }
}
.add-box /deep/ {
  .title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .el-input {
    width: 300px;
  }
  .el-form-item {
    padding-left: 0 !important;
  }
  .el-form-item__content {
    margin-left: 75px !important;
  }
  .el-form-item__label {
    height: 30px;
    width: 60px !important;
    text-align: justify;
  }
  .el-form-item__label:after {
    display: inline-block;
    content: "";
    padding-left: 100%;
  }
  .el-form-item {
    padding: 10px 30px;
  }
}
/* 去除验证的红色星号 */
.dis-flex
  /deep/
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: " ";
  width: 0px;
  margin-right: 0px;
}
</style>>
